import { MEDIA } from "@bridgesplit/ui";

export const POINTS_BREAKPOINT = MEDIA.XL;

export const REFERRAL_CODE_PLACEHOLDER = "XX123";
export const REFERRAL_PERCENTAGE = 0.05; // 5%
